import { Dispatch, SetStateAction } from "react";
import { useGetUsersForFilterQuery } from "../../../../api/filter/dataFilterApi";
import { VendedorAddedItem } from "./VendedorItem";

interface Props {
    visitaId: number;
    setIsAddVendedores: Dispatch<SetStateAction<boolean>>;
}

export function VendedoresAsignados({ visitaId, setIsAddVendedores }: Props) {

    const { data: vendedoresAsignados } = useGetUsersForFilterQuery({
        role: "Vendedor",
        dealId: visitaId.toString(),
        type: "include"
    }, { refetchOnMountOrArgChange: true });

    return (
        <div className="flex flex-col flex-1 my-2 h-full overflow-hidden">

            <div className="flex items-center justify-between">
                <p className="text-sms font-semibold">Vendedores agregados</p>

                <button
                    onClick={() => setIsAddVendedores(true)}
                    type="button"
                    className="bg-slate-700 border-0 border-gray-300 h-[26px] rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center text-sm text-white font-semibold">
                    + Vendedores
                </button>
            </div>

            {vendedoresAsignados != undefined && vendedoresAsignados.length > 0 && (
            <div className="my-2 overflow-auto">
                <div className="h-full overflow-auto">
                    {vendedoresAsignados?.map((vendedor, index) => (
                    <VendedorAddedItem
                        key={index}
                        id={vendedor.id}
                        nombre={vendedor.nombre}
                        visitaId={visitaId} />
                    ))}
                </div>
            </div>
            )}
        </div>
    )
}